// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    primary: {
        main: "#004FFF", // Primary -> Main
        contrast: "#FFFFFF", // None, look at primary button text color
        light: "#CCDCFF", // Primary -> Light
        dark: "#002A52", // Primary -> Dark
    },
    secondary: {
        main: "#002A52", // Secondary -> Main
        contrast: "#FFFFFF", // None, look at secondary button text color
        light: "#CCD4DD", // Secondary -> Light
        dark: "#667F98", // Secondary -> Dark
    },
    tertiary: {
        main: "#00F37B", // Tertiary -> Main
        contrast: "#002A52", // None, look at tertiary button text color
        light: "#D6FFEB", // Tertiary -> Light
        dark: "#00A252", // Tertiary -> Dark
    },
    common: {
        border: "#D9D9D9", // Border -> Border
        borderLight: "#F6F6F6", // Gray shades -> Light
        borderDark: "#E6E7E7", // Gray Shades -> Mid
        accent: "#F6F6F6",
        accentContrast: "#002A52", // Text Color -> Main
        accentContrastLight: "#52535A", // Gray Shades -> Main
        background: "#FFFFFF", // None, look at website background color
        backgroundContrast: "#002A52", // Text Color -> Main
        disabled: "#F6F6F6", // Gray shades -> Light
        disabledDark: "#E6E7E7", // Gray Shades -> Mid
        disabledContrast: "#002a5280", // Store Custom Code
        backgroundLight: "#EEF3FF", // Store Custom Code
    },
    text: {
        main: "#002A52", // Text Color -> Main
        accent: "#74757B", // Text Color -> Accent
        disabled: "#989AA9", // Text Color -> Semi
        link: "#004FFF", // Primary -> Main
        linkHover: "#002A52", // Primary -> Dark
        linkAlt: "#002A52", // Text Color -> Main
        linkAltHover: "#004FFF", // Primary -> Main
        input: "#002A52", // Text Color -> Main
        accentAlt: "#7E7F86", // Store Custom Code
    },
    success: {
        main: "#0F7B5C", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#E4F5F4", // Alerts/Light -> Success
    },
    warning: {
        main: "#A45E28", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#FFF5E9", // Alerts/Light -> Warning
    },
    danger: {
        main: "#CB2045", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#F5E8EA", // Alerts/Light -> Error
    },
    info: {
        main: "#004FFF", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#F0FAFF", // Alerts/Light -> Info
    },
    /* Store Custom Code - Start */
    lead: {
        main: "#002A52", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#ffffff", // Alerts/Light -> Info
    },
    /* Store Custom Code - End */
    neutral: {
        main: "#52535A", // None
        contrast: "#ffffff", // None
        light: "#f6f6f6", // None
    },
    invert: {
        main: "#FFFFFF", // None
        contrast: "#002A52", // Secondary -> Main
        hover: "#002A52", // Primary -> Dark
        dark: "#CCDCFF",
    },
    placeholder: {
        main: "#989AA9", // Text Color -> Semi
        disabled: "#989AA9", // Text Color -> Semi
    },
    button: {
        disabled: {
            main: "#F6F6F6", // Gray shades -> Light
            contrast: "#989AA9",
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#002A52", // Text Color -> Main
        hover: "#002A52", // Primary -> Dark
        accent: "#004FFF", // Primary -> Main
        accentHover: "#002A52", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#2A2B31", // Store Custom Code
            hover: "#2A2B31", // Store Custom Code
            underline: "#004FFF", // Primary -> Main
            accent: "#004FFF", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#004FFF", // Primary -> Main
            separator: "#D9D9D9", // Border -> Border
            border: "#D9D9D9", // Border -> Border
        },
        secondaryNavigation: {
            main: "#004FFF", // Primary -> Main
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
        megaMenuWithTabs: {
            tabsBackground: "#F6F6F6", // Gray Shades -> Light
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#F6F6F6", // Gray Shades -> Light
        contrast: "#002A52", // Text Color -> Main
        alt: "#002A52", // Primary -> Dark
        altContrast: "#FFFFFF", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#D9D9D9", // Border -> Border
        contrast: "#002A52", // Text Color -> Main
        hover: "#004FFF", // Primary -> Main
        selected: "#004FFF", // Primary -> Main
        selectedHover: "#002A52", // Primary -> Dark
        black: "#000",
    },
    tag: {
        color: "#2A2B31",
        iconColor: "#52535A",
    },
};

export default colors;
